export default class Modal {
  constructor() {
    if (this.setVars()) this.setEvent();
  }
  
  setVars() {
    this.settings = {
      modal: 'data-modal',
      close: 'data-modal-close',
      open: 'data-modal-open',
      darker: 'data-darker',
    }
    this.modal = document.querySelectorAll(`[${this.settings.modal}]`);
    return this.modal;
  }
  
  setEvent() {
    this.modal.forEach((modal, index) => {
      modal.querySelector(`[${this.settings.close}]`).addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        modal.removeClass('modalContact--active');
        document.querySelector(`[${this.settings.darker}]`).removeClass('darker--active');
      })
    });
  
    document.querySelectorAll(`[${this.settings.open}]`).forEach(modalButton => {
      modalButton.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
        
        if (!e.target.hasClass('disabled') && !e.target.getAttribute('disable')) {
          
          document.querySelector(`[${this.settings.modal}="${e.target.getAttribute(this.settings.open)}"]`)
                  .addClass('modalContact--active');
          
          document.querySelector(`[${this.settings.darker}]`)
                  .addClass('darker--active');
        }
      })
    });
  }
}
